<app-selector
  label="Pipe Puzzle Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="pathFinderGameCoreService.pathFinderGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="pathFinderGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
